import { ApplicantionFromToken } from '../../models/doc-upload.model';
import { PlaidStatus } from '../../services/plaid.types';
import { RootState } from '../types';

export const getPlaidUserInfo = (rootState: RootState) => rootState.getIn(['ui', 'plaidUserInfo']) as PlaidStatus;
export const getEnableDocUpload = (rootState: RootState) => rootState.getIn(['ui', 'enableDocUpload']) as boolean;
export const getUserDetails = (rootState: RootState) => rootState.getIn(['ui', 'userDetails']) as ApplicantionFromToken | null;
